<template>
  <v-container>
    <Dialog
      :show="adDialog"
      :object="objDelete"
      @delete="eliminar"
      @close="close"
    />
    <Modal
      @save="guardar"
      @close="close"
      :object="itemAct"
      :update="update"
      :detalle="detalle"
      :show="abrirModal"
    />
    <template>
      <v-row>
        <v-col cols="12" md="11">
          <span class="align-center headline">
            
          </span>
        </v-col>
        <v-col cols="12" md="1">
          <v-btn color="primary" dark class="mb-2" @click="nuevo">Nuevo</v-btn>
        </v-col>
      </v-row>
    </template>
    <Table
      @edit="editarClick"
      @delete="eliminarClick"
      @detalle="detalleClick"
      :headers="headers"
      :arrayList="clientes"
      :opciones="true"
      :title="clientesStr"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Table from "@/components/base/Table.vue";
import Modal from "@/components/base/modal/ModalCliente.vue";
import Dialog from "@/components/base/Dialog";
import Headers from "../headers"
import moment from "moment";

export default {
  data() {
    return {
      headers: Headers.headersClientes,
      abrirModal: false,
      clientesStr: 'Clientes',
      itemAct: {
        tipo_cliente:null,
        nombre:null,
        apellido:null,
        email:null,
        fecha_nacimiento:moment( new Date() ).format('LL'),
        pais:null,
        tipo_documento:null,
        num_documento:null,
        doc_expedido:moment( new Date() ).format('LL'),
        doc_vencimiento:moment( new Date() ).format('LL'),
        licencia:null,
        lic_expedido:moment( new Date() ).format('LL'),
        lic_vencimiento:moment( new Date() ).format('LL'),
        telefono:null,
        telefono_movil:null,
        direccion_habitual:null,
        municipio_habitual:null,
        provincia_habitual:null,
        direccion_local:null,
        municipio_local:null,
        provincia_local:null,
        reputacion:null,
        imagen:null,
        observaciones:null,
      },
      objDelete: {
        element: 'Cliente',
        id: '',
        obj: {}
      },
      update: false,
      detalle: false,
      adDialog: false,
    };
  },
  components: {
    Table,
    Modal,
    Dialog,
  },
  computed: {
    ...mapState("usuarioNamespace", ["token", "usuario"]),
    ...mapState("clienteNamespace", ["cliente", "clientes"]),
  },
  methods: {
    ...mapActions("clienteNamespace", [
      "getCliente",
      "getClientes",
      "saveCliente",
      "updateCliente",
      "deleteCliente",
      "deactivateCliente",
      "activateCliente",
    ]),
    editarClick(obj) {
      debugger;
      this.update = true;
      this.itemAct = obj;
      this.abrirModal = true;
    },
    eliminarClick(obj) {
      this.adDialog = true;
      this.objDelete.id = obj.id;
      this.objDelete.obj = obj
    },
    detalleClick(obj) {
      debugger;
      this.detalle = true;
      this.itemAct = obj;
      this.abrirModal = true;
    },
    nuevo() {
      this.update = false;
      this.abrirModal = true;
    },
    guardar(obj) {
      debugger;
      if (this.update) {
        this.updateCliente({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      } else {
        this.saveCliente({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      }
      this.close();
      this.getClientes();
    },
    eliminar(obj) {
      this.deleteCliente({
        token: this.token,
        id: obj.id,
      });
      this.close();
    },
    close() {
      this.detalle = false;
      this.update = false;
      this.itemAct = {}
      this.abrirModal = false;
      this.adDialog = false;
    },
  },
};
</script>